var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9268 2C19.536 2 21.084 2.61833 22.2228 3.72783C23.3628 4.835 24 6.32833 24 7.89167V17.1083C24 20.3633 21.276 23 17.9268 23H6.072C2.7228 23 0 20.3633 0 17.1083V7.89167C0 4.63667 2.7108 2 6.072 2H17.9268ZM19.8356 9.62981L19.9316 9.53648C20.2184 9.19815 20.2184 8.70815 19.9184 8.36981C19.7516 8.19598 19.5224 8.08981 19.2836 8.06648C19.0316 8.05365 18.7916 8.13648 18.6104 8.29981L13.1996 12.4998C12.5036 13.061 11.5064 13.061 10.7996 12.4998L5.39962 8.29981C5.02642 8.03148 4.51042 8.06648 4.19962 8.38148C3.87562 8.69648 3.83962 9.19815 4.11442 9.54815L4.27162 9.69981L9.73162 13.8415C10.4036 14.3548 11.2184 14.6348 12.0716 14.6348C12.9224 14.6348 13.7516 14.3548 14.4224 13.8415L19.8356 9.62981Z",
    fill: "#39434D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ebec1f9f.svg";
export { ForwardRef as ReactComponent };